import { ChangeDetectionStrategy, Component, Injector, OnInit } from '@angular/core';
import { practitionerI } from 'app/core/interfaces/practitioner';
import { DialogService } from 'app/services/dialog.service';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { PractitionerSecretariesAffiliationService } from 'app/core/http/services/practititoner-secretaries-affiliation.service';
import { PractitionerroleService } from 'app/core/http/services/practitionerrole.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { PractionerSecretaryDetailsComponent } from './details/practitioner-details.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'page-practioner-secretary',
  templateUrl: './practioner.component.html',
  styleUrls: ['./practioner.component.scss'],
})
export class PractionerSecretaryComponent extends BaseComponent implements OnInit {
  public practitioners: any[] = [];
  public title = 'Especialistas';

  public affiliations: any[] = [];
  public practitionerRole: any[] = [];

  public secretaryLogged: any = {};
  public practitionersAffiliation: any[] = [];
  public isPractitionersLoaded: boolean = false;

  public get practitionerActive(): any[] {
    return this.practitionersAffiliation?.filter((item: any) => item.status === 'accepted');
  }

  public get practitionerInactive(): any[] {
    return this.practitionersAffiliation?.filter((item: any) => item.status === 'canceled');
  }

  public get practitionerPending(): any[] {
    return this.practitionersAffiliation?.filter((item: any) => item.status === 'requested');
  }

  constructor(
    private injector: Injector,
    private dialogService: DialogService,
    private practitionerService: PractitionerService,
    private practitionerRoleService: PractitionerroleService,
    private affiliationService: PractitionerSecretariesAffiliationService
  ) {
    super(injector);
    this.currentUser = this.auth.currentUserValue;
  }

  async ngOnInit() {
    this.secretaryLogged = this.getUserLogged();

    try {
      await this.getPractitioners();
      await this.getAffiliations();
      this.getPractitionerRole(); // Não é assíncrono, então pode ser chamado diretamente
    } catch (err) {
      console.error('Erro ao carregar dados', err);
    }
  }

  transformPractionerRoleToForm(dadosOriginais: any) {
    const crm = dadosOriginais.identifier[0].value;
    const organization_name = dadosOriginais.organization.display;
    const organization_id = dadosOriginais.organization.references.split('/').pop();
    const practitioner_id = dadosOriginais.practitioner.references.split('/').pop();
    const practitioner_name = dadosOriginais.practitioner.display;
    const speciality = dadosOriginais.specialty;

    const novoObjeto = {
      practitionerrole_id: dadosOriginais.practitionerrole_id,
      crm: crm,
      organization_name: organization_name,
      organization_id: organization_id,
      practitioner_id: practitioner_id,
      practitioner_name: practitioner_name,
      speciality: speciality,
    };

    return novoObjeto;
  }

  getPractitionerRole() {
    const practitionerRolemOck = [
      {
        practitionerrole_id: '82b55c61-778e-4860-92b2-ac796de3b8db',
        active: true,
        identifier: [
          {
            system: 'CRM',
            value: '56789',
          },
        ],
        organization: {
          display: 'Ritmo Cor',
          references: 'organization/123445',
        },
        practitioner: {
          display: 'Dr Ailton',
          references: 'practitioner/c86b2339-41da-4e91-9ddd-c0edee6a5911',
        },
        specialty: 'Neurologia',
        telecom: '',
      },
    ];

    this.practitionerRole = practitionerRolemOck.map((item) => this.transformPractionerRoleToForm(item));
  }

  getRole(practitioner: any) {
    return this.practitionerRole.find((registro) => registro.practitioner_id == 'c86b2339-41da-4e91-9ddd-c0edee6a5911');
  }

  getSpecialization(practitioner: any) {
    return 'Cardiologista';

    const role = this.getRole(practitioner);

    if (!role) return '';
    return role.speciality;
  }

  getCity(practioner: any) {
    return practioner?.address[0]?.city || null;
  }

  convertObject(original: any) {
    return {
      id: null,
      name: original.name,
      birthDate: original.birthDate,
      gender: original.gender,
      cpf: original.identifier.find((id: any) => id.system === 'CPF')?.value || '',
      crm: '',
      address: original.address[0],
      mail: '',
      active: original.status,
      qualifications: original.qualification.map((q: any) => ({
        id: 0,
        name: q.code.text || '',
        institution: q.issuer.display,
        dateConclusion: q.period.end,
        type: q.code.type === 'QUALIFICATION' ? 'qualification' : 'course',
      })),
      certificates: [],
      languages: original?.communication.map((lang: any) => ({
        name: lang.language,
        institution: '',
        type: '',
      })),
    };
  }

  async getPractionersAffiliations(): Promise<any[]> {
    const practitionerIdsAffiliation = new Set(this.affiliations.map((objeto) => objeto.practitioner_id));

    const practitioners = this.practitioners.filter((objeto) => practitionerIdsAffiliation.has(objeto.practitioner_id));

    const mapaPractitionerIdPrimeiroObjeto = new Map(this.affiliations.map((objeto) => [objeto.practitioner_id, objeto]));

    return practitioners.map((objeto) => ({
      ...(mapaPractitionerIdPrimeiroObjeto.get(objeto.practitioner_id) || {}),
      ...objeto,
    }));
  }

  async getAffiliations() {
    try {
      const resAffiliation: any = await this.affiliationService.listPractitionerLinkedWithSecretary(this.secretaryLogged.id).toPromise();
      this.affiliations = this.transformFhirToModel(resAffiliation);

      this.practitionersAffiliation = await this.getPractionersAffiliations();
      this.isPractitionersLoaded = true;
    } catch (err) {
      console.log('Affiliation error', err);
      this.isPractitionersLoaded = true;
    }
  }

  async getPractitioners() {
    try {
      const response: any = await this.practitionerService.list().toPromise();
      this.practitioners = Array.isArray(response) ? response : []; // Garantir que é um array
    } catch (err) {
      console.log('Falha ao buscar especialistas', err);
    }
  }

  transformFhirToModel(jsonData: any[]) {
    return jsonData.map((item) => {
      const {
        affiliation_id,
        request: { id: secretary_id, display: secretary_name },
        subject: { id: practitioner_id, display: practitioner_name },
        status,
      } = item;

      return {
        affiliation_id,
        secretary_name,
        secretary_id,
        practitioner_name,
        practitioner_id,
        status,
      };
    });
  }

  getPrefix(practitioner: practitionerI) {
    if (practitioner.gender) {
      return practitioner.gender == 'Female' ? 'Dra. ' : 'Dr. ';
    }
    return '';
  }

  openPractitionerDetailsForm(practitioner: any) {
    const data = {
      title: practitioner.name,
      param: {
        practitionerRole: this.getRole(practitioner),
        practioner: practitioner,
      },
    };

    this.dialog.openComponentDialog(PractionerSecretaryDetailsComponent, data);
  }

  openForm() {
    this.dialogService
      .openPractitionerSecretaryLinkDialog({
        title: 'Vincular novo especialista',
        component: 'practitioner-registration',
        param: {
          practitionerRole: this.practitionerRole,
          affiliations: this.affiliations,
        },
      })
      .subscribe({
        next: (refreshComponent) => {
          if (refreshComponent) {
            this.getPractitioners();
            this.getAffiliations();
          }
        },
      });
  }
}
